import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { FiTool } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import PaginationCustom from '../components/Pagination';
import TableComponent from '../components/TableComponent';
import { fetchMaintenanceData } from '../store/Slices/MaintenanceSlice';

const Maintenance = () => {
  const dispatch = useDispatch();
  const { data = [], loading = false, error = null, meta } = useSelector((state) => state.maintenance);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const maintenanceColumnsLabels = [
    { value: "sr_no", label: "S No." },
    { value: "reg_no", label: "Reg No." },
    { value: "maintenance_complete_date", label: "Maintenance Complete Date" },
    { value: "system_code2", label: "System Code" },
    { value: "maintenance_type", label: "Maintenance Type" },
    { value: "vehicle_brand", label: "Vehicle Brand" },
    { value: "category", label: "Category" },
    { value: "vehicle_category", label: "Vehicle Category" },
    { value: "maintenance_description", label: "Maintenance Description" },
    { value: "part_number", label: "Part Number" },
    { value: "part_description", label: "Part Description" },
    { value: "part_manufacturer", label: "Part Manufacturer" },
    { value: "qty", label: "Quantity" },
    { value: "units", label: "Units" },
    { value: "rate", label: "Rate" },
    { value: "expense_amount", label: "Expense Amount" },
    { value: "mode_of_payment", label: "Mode of Payment" },
    { value: "maintenance_location", label: "Maintenance Location" },
    { value: "maintenance_lacation_standarized", label: "Standardized Location" },
    { value: "operation", label: "Operation" },
    { value: "capacity", label: "Capacity" },
    { value: "maintenance_status", label: "Maintenance Status" },
    { value: "serviced_by", label: "Serviced By" },
    { value: "hmt", label: "HMT" },
    { value: "hmt_drive_mode", label: "HMT Drive Mode" },
    { value: "request_date", label: "Request Date" },
    { value: "requested_by", label: "Requested By" },
    { value: "request_approved_by", label: "Request Approved By" },
    { value: "approved_by", label: "Approved By" },
    { value: "work_done_by", label: "Work Done By" }
  ];

  useEffect(() => {
    setCurrentPage(1);
  }, [limit])

  useEffect(() => {
    dispatch(fetchMaintenanceData({
      page: currentPage,
      limit: limit
    }));
  }, [dispatch, currentPage, limit]);

  const refreshMaintenanceData = () => {
    dispatch(fetchMaintenanceData({
      page: currentPage,
      limit: limit
    }));
  };

  if (loading) {
    return <div className='loading_spinner'><Spinner animation="grow" /></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const csvType = {
    value: "maintenance",
    label: "Maintenance"
  }

  return (
    <div className='table_main_wrapper'>
      <TableComponent
        heading="Maintenance"
        icon={<FiTool />}
        columns={maintenanceColumnsLabels}
        data={data}
        currentPage={currentPage}
        showAddBtn={true}
        className="maintenance_heading"
        csvType={csvType}
        innerHeadingClass="maintenance_inner_heading"
        onImportSuccess={refreshMaintenanceData}
      />

      {
        data?.length > 0 &&
        <PaginationCustom totalPages={meta?.totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} limit={limit} setLimit={setLimit} />
      }
    </div>
  )
}

export default Maintenance